<div class="w-full max-w-[560px] p-6 bg-white rounded-2xl">
  <div class="flex items-center justify-between mb-5">
    <h2 class="text-xl font-semibold text-primary-dark">Editar Texto de Notificação</h2>
    <button
      type="button"
      class="w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 transition-colors"
      (click)="close()"
      aria-label="Fechar"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" class="flex flex-col gap-4" (ngSubmit)="submit()">
    <div>
      <label class="input-label">
        Texto da Notificação <span class="text-red-600">*</span>
      </label>
      <textarea
        #templateInput
        rows="6"
        formControlName="template"
        class="w-full px-3 py-2.5 border rounded-lg input-field-focus resize-y"
        [class.border-red-500]="form.controls.template.invalid && form.controls.template.touched"
      ></textarea>
      <p *ngIf="form.controls.template.invalid && form.controls.template.touched" class="mt-1 text-xs text-red-600">
        O texto da notificação é obrigatório.
      </p>
    </div>

    <div class="rounded-xl border border-blue-200 bg-blue-50 p-4">
      <div class="flex items-start gap-3 mb-3">
        <mat-icon class="text-primary">info</mat-icon>
        <div>
          <h3 class="text-sm font-semibold text-primary-dark">Observação Importante</h3>
          <p class="text-xs text-gray-700 mt-1">
            Clique em uma variável para inserir automaticamente no texto da notificação.
          </p>
        </div>
      </div>

      <div class="flex flex-wrap gap-2 mb-3">
        <button
          *ngFor="let variable of variables"
          type="button"
          class="px-2.5 py-1.5 rounded-lg text-xs font-medium bg-white border border-blue-200 text-primary hover:bg-blue-100 transition-colors"
          (click)="addVariable(variable.token)"
        >
          {{ variable.token }}
        </button>
      </div>

      <div class="flex flex-col gap-1">
        <p *ngFor="let variable of variables" class="text-xs text-gray-700">
          <span class="font-semibold text-primary-dark">{{ variable.token }}</span> - {{ variable.label }}
        </p>
      </div>
    </div>

    <button
      type="submit"
      [disabled]="isSubmitting"
      class="w-full rounded-lg bg-primary text-white py-3 font-medium disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ isSubmitting ? 'Atualizando...' : 'Atualizar Texto' }}
    </button>
  </form>
</div>
